import React, { Component } from "react";
import {
  alert,
  float,
  toFixed,
  format_date,
  GET,
  POST,
  PUT,
  DELETE,
  loading,
  required,
  Navbar,
  Modal,
  captureShareImage,
  sendShareToTelegram,
  downloadShareImage,
  Switch,
  Select,
  profile
} from "../../components/CustomComponent.js";
import { NumericFormat } from "react-number-format";
import GatewayLogo from "../../components/GatewayLogo.js";
import NOTIFICATION from "../../assets/images/noti/noti_system6_1.png";
import { PROCESS_TYPES, processTypeStyle } from "../../components/process-type.js";

// Payment Switch is driven by these two tables: the system level lives on the
// center config row (one flag per currency + direction), the gateway level on
// gateway_rules.country / is_*_active. Same currency codes on both sides
// ("THB" / "LAK"), so one list drives the whole section.
const PAYMENT_CURRENCIES = [
  {
    code: "THB",
    label: "Thai Baht",
    deposit_key: "is_deposit_active_thb",
    withdrawal_key: "is_withdrawal_active_thb",
  },
  {
    code: "LAK",
    label: "Lao Kip",
    deposit_key: "is_deposit_active_lak",
    withdrawal_key: "is_withdrawal_active_lak",
  },
];

const PAYMENT_DIRECTIONS = [
  { key: "deposit", label: "Deposit", gateway_key: "is_deposit_active" },
  { key: "withdrawal", label: "Withdrawal", gateway_key: "is_withdrawal_active" },
];

// The gateway block writes to gateway-rules/update, so it is only shown to
// roles that hold that permission (Navbar's class based removal only runs on
// mount, and this section renders on tab click).
const CAN_EDIT_GATEWAY = !!profile?.role?.permission?.includes(
  "gateway-rules.update"
);

// Config Company: master ของ company ต่อ gateway (เพดาน GMV วัน/เดือนใช้ร่วมกันทุก broker)
const CAN_EDIT_COMPANY = !!profile?.role?.permission?.includes("center-configs.update");
const fmtTHB = (v) => (v === null || v === undefined || v === "" ? "Unlimited" : Number(v).toLocaleString(undefined, { maximumFractionDigits: 2 }));
const toInput = (v) => (v === null || v === undefined || Number(v) <= 0 ? "" : String(Number(v)));
// Seller info of a company (printed on the invoice of orders from its PresentGateway)
const COMPANY_SELLER_FIELDS = ["process_type", "legal_name", "legal_address", "tax_id", "phone"];
const PROCESS_TYPE_SELECT = [{ value: "", label: "None (not linked)" }, ...PROCESS_TYPES.map((p) => ({ value: p.value, label: p.label }))];
const onlyDigits = (v) => String(v ?? "").replace(/\D/g, "");
const isTaxIdValid = (v) => !v || /^\d{13}$/.test(v);
const toSellerDraft = (c) => ({
  process_type: c.process_type || "",
  legal_name: c.legal_name || "",
  legal_address: c.legal_address || "",
  tax_id: c.tax_id || "",
  phone: c.phone || "",
});
const toLimit = (v) => (v === "" || v === null || v === undefined || Number(v) <= 0 ? null : Number(v));

const SWITCH_PROPS = {
  onColor: "#c9a23a",
  offColor: "#cbd5e1",
  onHandleColor: "#ffffff",
  checkedIcon: false,
  uncheckedIcon: false,
  height: 22,
  width: 42,
  handleDiameter: 16,
  activeBoxShadow: "0 0 0 3px rgba(212, 175, 55, 0.3)",
};

const SECTIONS = [
  { key: "general", label: "General", icon: "\uf1de", desc: "Cutoff tier and global parameters" },
  { key: "commission", label: "Commission", icon: "\uf295", desc: "Dev commission percentage per currency" },
  { key: "safety", label: "Safety Balance", icon: "\uf3ed", desc: "Payout balance thresholds that trigger a notification" },
  { key: "payment", label: "Payment Switch", icon: "\uf205", desc: "Turn deposits and withdrawals on or off at system and gateway level" },
  { key: "companies", label: "Config Company", icon: "\uf1ad", desc: "Companies per gateway with shared daily and monthly GMV limits across all brokers" },
  { key: "announcement", label: "Announcement", icon: "\uf0a1", desc: "Maintenance notice sent to Telegram rooms" },
  { key: "summary", label: "Summary", icon: "\uf46d", desc: "Current configuration at a glance" },
];

export default class Logs extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      cutoff_tier: null,
      payment_min_deposit: "",
      payment_max_deposit: "",
      payment_min_withdrawal: "",
      payment_max_withdrawal: "",
      cradit_balance: "",
      dev_commission_percentage: "",
      dev_commission_percentage_lak: "",
      announce_datetime: "",
      announce_duration: "",
      announce_detail: "",
      safety_balance: "",
      safety_balance_lak: "",
      is_deposit_active_thb: true,
      is_withdrawal_active_thb: true,
      is_deposit_active_lak: true,
      is_withdrawal_active_lak: true,

      active_section: "commission",

      // Gateway level of Payment Switch. `gateways_origin` keeps the loaded
      // state so only the rows the user actually flipped are sent on save.
      gateways: [],
      gateways_origin: [],
      gateways_loaded: false,

      // Config Company
      companies: [],
      companies_loaded: false,
      company_gateway: "",
      company_drafts: {},
      company_saving: "",

      modal_share: false,
      share_image: null,
      chat_id: ""
    };
  }

  async componentDidMount() {
    loading(false);
    await this.Get();
    if (CAN_EDIT_GATEWAY) await this.GetGateways();
  }
   async componentDidUpdate() {
  }
  Get = async () => {
    loading(true);
    let result = await GET("v1/admin/center-configs/list", null);
    if (result?.status) {
      let data = result.data;
      this.setState({
        uid: data.uid,
        cutoff_tier: data.cutoff_tier,
        payment_min_deposit: Number(data.payment_min_deposit),
        payment_max_deposit: Number(data.payment_max_deposit),
        payment_min_withdrawal: Number(data.payment_min_withdrawal),
        payment_max_withdrawal: Number(data.payment_max_withdrawal),
        cradit_balance: Number(data.cradit_balance),
        dev_commission_percentage: Number(data.dev_commission_percentage),
        dev_commission_percentage_lak: Number(data.dev_commission_percentage_lak),
        announce_datetime: data.announce_datetime,
        announce_duration: Number(data.announce_duration || 0),
        announce_detail: data.announce_detail,
        safety_balance: Number(data.safety_balance),
        safety_balance_lak: Number(data.safety_balance_lak),
        is_deposit_active_thb: data.is_deposit_active_thb,
        is_withdrawal_active_thb: data.is_withdrawal_active_thb,
        is_deposit_active_lak: data.is_deposit_active_lak,
        is_withdrawal_active_lak: data.is_withdrawal_active_lak,
      });
    }
    loading(false);
  };
  // page=0 makes gateway-rules/list return every row without pagination.
  GetGateways = async () => {
    let result = await GET("gateway-rules/list", { page: 0 });
    let gateways = [];
    if (result?.status) {
      gateways = (result.data || [])
        .map((item) => ({
          uid: item.uid,
          gateway_name: item.gateway_name,
          gateway_code: item.gateway_code,
          country: (item.country || "").toUpperCase(),
          is_deposit_active: !!item.is_deposit_active,
          is_withdrawal_active: !!item.is_withdrawal_active,
        }))
        .sort((a, b) =>
          (a.gateway_name || "").localeCompare(b.gateway_name || "")
        );
    }
    this.setState({
      gateways,
      gateways_origin: gateways.map((item) => ({ ...item })),
      gateways_loaded: true,
    });
  };
  ToggleGateway = (uid, field, value) => {
    this.setState((state) => ({
      gateways: state.gateways.map((item) =>
        item.uid === uid ? { ...item, [field]: value } : item
      ),
    }));
  };
  ToggleGatewayGroup = (country, field, value) => {
    this.setState((state) => ({
      gateways: state.gateways.map((item) =>
        item.country === country ? { ...item, [field]: value } : item
      ),
    }));
  };
  IsGatewayChanged = (item) => {
    const origin = this.state.gateways_origin.find((e) => e.uid === item.uid);
    if (!origin) return false;
    return (
      origin.is_deposit_active !== item.is_deposit_active ||
      origin.is_withdrawal_active !== item.is_withdrawal_active
    );
  };
  ChangedGateways = () => this.state.gateways.filter(this.IsGatewayChanged);

  // ---- Config Company ---------------------------------------------------
  GetCompanies = async () => {
    const result = await GET("v1/admin/gateway-companies", null);
    const companies = result?.status ? result.data || [] : [];
    const drafts = {};
    companies.forEach((c) => {
      drafts[c.uid] = { company_name: c.company_name, business_type: c.business_type, limit_gmv_per_day: toInput(c.limit_gmv_per_day), limit_gmv_per_month: toInput(c.limit_gmv_per_month), ...toSellerDraft(c) };
    });
    // แถวใหม่ที่ยังไม่บันทึกคงไว้
    Object.entries(this.state.company_drafts).forEach(([k, v]) => { if (k.startsWith("new-")) drafts[k] = v; });
    this.setState({ companies, companies_loaded: true, company_drafts: drafts });
  };
  OpenCompanies = async () => {
    this.setState({ active_section: "companies" });
    if (!this.state.gateways_loaded) await this.GetGateways();
    if (!this.state.companies_loaded) await this.GetCompanies();
    if (!this.state.company_gateway) {
      const first = this.state.companies[0]?.gateway_name || this.state.gateways[0]?.gateway_name || "";
      this.setState({ company_gateway: first });
    }
  };
  SetCompanyDraft = (key, field, value) => {
    this.setState((state) => ({ company_drafts: { ...state.company_drafts, [key]: { ...state.company_drafts[key], [field]: value } } }));
  };
  AddCompanyDraft = () => {
    const key = `new-${Date.now()}`;
    this.setState((state) => ({
      company_drafts: { ...state.company_drafts, [key]: { gateway_name: state.company_gateway, company_name: "", business_type: "", limit_gmv_per_day: "", limit_gmv_per_month: "", ...toSellerDraft({}) } },
    }));
  };
  RemoveCompanyDraft = (key) => {
    this.setState((state) => {
      const drafts = { ...state.company_drafts };
      delete drafts[key];
      return { company_drafts: drafts };
    });
  };
  IsCompanyChanged = (c) => {
    const d = this.state.company_drafts[c.uid];
    if (!d) return false;
    return d.company_name !== c.company_name || d.business_type !== c.business_type || toLimit(d.limit_gmv_per_day) !== toLimit(c.limit_gmv_per_day) || toLimit(d.limit_gmv_per_month) !== toLimit(c.limit_gmv_per_month) || COMPANY_SELLER_FIELDS.some((f) => (d[f] || "") !== (c[f] || ""));
  };
  SaveCompany = async (key, company) => {
    const d = this.state.company_drafts[key];
    if (!d?.company_name || !d?.business_type) {
      alert("", "warning", "Warning", "Please select Company Name and Business Type");
      return;
    }
    if (!isTaxIdValid(d.tax_id)) {
      alert("", "warning", "Warning", "Tax ID must be exactly 13 digits");
      return;
    }
    const body = {
      company_name: d.company_name,
      business_type: d.business_type,
      limit_gmv_per_day: toLimit(d.limit_gmv_per_day),
      limit_gmv_per_month: toLimit(d.limit_gmv_per_month),
      process_type: d.process_type || null,
      legal_name: (d.legal_name || "").trim() || null,
      legal_address: (d.legal_address || "").trim() || null,
      tax_id: d.tax_id || null,
      phone: (d.phone || "").trim() || null,
    };
    this.setState({ company_saving: key });
    const result = company
      ? await PUT("v1/admin/gateway-companies/" + company.uid, body, { keepEmpty: true })
      : await POST("v1/admin/gateway-companies", { ...body, gateway_name: d.gateway_name }, { keepEmpty: true });
    if (result?.status) {
      if (!company) this.RemoveCompanyDraft(key);
      await this.GetCompanies();
      alert("", "success", "Saved", company?.broker_count ? `Updated for ${company.broker_count} broker gateway(s)` : "");
    }
    this.setState({ company_saving: "" });
  };
  DeleteCompany = async (company) => {
    if (!(await alert("", "warning", "Delete company", `Delete ${company.company_name} : ${company.business_type} from ${company.gateway_name}?`, "Delete", "cancel"))) return;
    const result = await DELETE("v1/admin/gateway-companies/" + company.uid, {});
    if (result?.status) await this.GetCompanies();
  };
  // Only the Active flags are sent — the rest of the gateway rule (limits,
  // fees) stays owned by the Gateway Settings page.
  SaveGateways = async () => {
    const changed = this.ChangedGateways();
    const failed = [];
    for (const item of changed) {
      let result = await PUT("gateway-rules/update/" + item.uid, {
        is_deposit_active: item.is_deposit_active,
        is_withdrawal_active: item.is_withdrawal_active,
      });
      if (!result?.status) failed.push(item.gateway_name || item.gateway_code);
    }
    if (changed.length) await this.GetGateways();
    return failed;
  };
  Update = async () => {
    const {
      uid,
      cutoff_tier,
      payment_min_deposit,
      payment_max_deposit,
      payment_min_withdrawal,
      payment_max_withdrawal,
      cradit_balance,
      dev_commission_percentage,
      dev_commission_percentage_lak,
      announce_datetime,
      announce_duration,
      announce_detail,
      safety_balance,
      safety_balance_lak,
      is_deposit_active_thb,
      is_withdrawal_active_thb,
      is_deposit_active_lak,
      is_withdrawal_active_lak,
    } = this.state;
    if (
      await alert(
        "",
        "info",
        "Confirm",
        "Do you want to confirm the submission?",
        "Confirm",
        "Cancel"
      )
    ) {
      loading(true);
      let body = {
        cutoff_tier: cutoff_tier || null,
        payment_min_deposit: Number(payment_min_deposit),
        payment_max_deposit: Number(payment_max_deposit),
        payment_min_withdrawal: Number(payment_min_withdrawal),
        payment_max_withdrawal: Number(payment_max_withdrawal),
        cradit_balance: Number(cradit_balance),
        dev_commission_percentage: Number(dev_commission_percentage),
        dev_commission_percentage_lak: Number(dev_commission_percentage_lak),
        announce_datetime: announce_datetime,
        announce_duration: Number(announce_duration),
        announce_detail: announce_detail,
        safety_balance: Number(safety_balance),
        safety_balance_lak: Number(safety_balance_lak),
        is_deposit_active_thb,
        is_withdrawal_active_thb,
        is_deposit_active_lak,
        is_withdrawal_active_lak,
      };

      let result = await PUT("v1/admin/center-configs/update/" + uid, body);
      if (result?.status) {
        const failed = await this.SaveGateways();
        if (failed.length) {
          alert(
            "",
            "warning",
            "Warning",
            `Some gateways could not be updated: ${failed.join(", ")}`
          );
        } else {
          alert("#", "success");
        }
      } else {
        alert(
          "",
          "warning",
          "Warning",
          result?.message || "An error occurred. Please try again."
        );
      }
      loading(false);
    }
  };

  Share = async () => {
    this.setState({ chat_id: global.chat_room[0].list[0].value });
    if (!this.share) return;
    loading(true);

  const image = await captureShareImage(this.share);
  this.setState({modal_share: true, share_image: image});

  loading(false);
  };
  SubmitShare = async () => {
    loading(true);
    const { share_image, chat_id } = this.state;
    await sendShareToTelegram(chat_id, `Announcement from Payment Broker`, share_image);
    loading(false);
    alert("", "success");
    this.setState({modal_share: false});

  }
  DownloadShare = () => {
    downloadShareImage(this.state.share_image);
  }

  // ---- UI helpers ------------------------------------------------------
  renderToggle = ({ icon, title, desc, checked, onChange }) => (
    <label className={`pu-toggle ${checked ? "on" : ""}`}>
      <span className="pu-toggle-icon icon">{icon}</span>
      <span className="flex-grow-1 min-w-0">
        <span className="pu-toggle-title">{title}</span>
        <span className="pu-toggle-desc">{desc}</span>
      </span>
      <span className={`pu-cc-onoff ${checked ? "on" : "off"}`}>
        {checked ? "ON" : "OFF"}
      </span>
      <Switch {...SWITCH_PROPS} onChange={onChange} checked={checked} />
    </label>
  );
  renderField = ({ label, hint, suffix, isRequired, children }) => (
    <div className="mb-3">
      <label className="pr-label">
        {label}
        {isRequired ? required : null}
      </label>
      <div className="position-relative">
        {children}
        {suffix && <span className="pu-input-suffix">{suffix}</span>}
      </div>
      {hint && <div className="pu-hint">{hint}</div>}
    </div>
  );
  renderSectionHead = (section) => (
    <div className="pu-cc-head">
      <span className="pu-cc-head-icon icon">{section.icon}</span>
      <div>
        <div className="pu-cc-head-title">{section.label}</div>
        <div className="pu-cc-head-desc">{section.desc}</div>
      </div>
    </div>
  );
  kv = (label, value, extraClass) => (
    <div className="pu-kv">
      <span className="pu-kv-label">{label}</span>
      <span className={`pu-kv-value ${extraClass || ""}`}>{value}</span>
    </div>
  );

  // ---- Config Company ---------------------------------------------------
  renderUsageBar = (label, usage, limit) => {
    const amount = Number(usage?.total_amount) || 0;
    const lim = toLimit(limit);
    const percent = lim ? (amount / lim) * 100 : null;
    const tone = percent === null ? "none" : percent >= 90 ? "danger" : percent >= 80 ? "warn" : "ok";
    return (
      <div className="gc-usage">
        <div className="d-flex justify-content-between gc-usage-text">
          <span>{label}</span>
          <span>
            <b>{fmtTHB(amount)}</b> / {fmtTHB(lim)}
            {percent !== null && <span className={`gc-pct ${tone}`}>{percent.toFixed(1)}%</span>}
          </span>
        </div>
        <div className="gc-bar"><div className={`gc-bar-fill ${tone}`} style={{ width: `${percent === null ? 0 : Math.min(100, percent)}%` }} /></div>
      </div>
    );
  };
  renderPresentGatewayBadge = (value) => {
    const s = processTypeStyle(value);
    return (
      <span className="d-inline-flex align-items-center" title={`PresentGateway: ${s.label}`} style={{ marginLeft: 8, padding: "2px 8px", borderRadius: 999, background: s.background, color: s.color, border: s.border, fontSize: 11, lineHeight: 1.2, gap: 4, verticalAlign: 2, fontWeight: 700 }}>
        <span className="icon" style={{ fontSize: 10 }}>{s.icon}</span>
        <span>{s.label}</span>
      </span>
    );
  };
  renderCompanyCard = (key, company) => {
    const d = this.state.company_drafts[key] || {};
    const is_new = !company;
    const changed = is_new || this.IsCompanyChanged(company);
    const saving = this.state.company_saving === key;
    const companyOptions = [...new Set([...(global.gateway_company || []).map((e) => e.value), d.company_name].filter(Boolean))].map((v) => ({ value: v, label: v }));
    const typeOptions = [...new Set([...(global.business_type || []).map((e) => e.value), d.business_type].filter(Boolean))].map((v) => ({ value: v, label: v }));
    return (
      <div className={`gc-card ${is_new ? "new" : ""}`} key={key}>
        <div className="gc-card-head">
          <div className="d-flex align-items-center gap-2 min-w-0">
            <span className="gc-card-icon icon">{"\uf1ad"}</span>
            <div className="min-w-0">
              <div className="gc-card-title text-truncate">{d.company_name || "New company"}{d.business_type ? <span className="gc-card-type">{d.business_type}</span> : null}{d.process_type ? this.renderPresentGatewayBadge(d.process_type) : null}</div>
              <div className="gc-card-sub">
                {is_new ? "Not saved yet" : company.broker_count ? `Used by ${company.broker_count} broker gateway${company.broker_count === 1 ? "" : "s"}` : "Not used by any broker yet"}
              </div>
            </div>
          </div>
          {changed && !is_new && <span className="gc-unsaved">Unsaved</span>}
        </div>
        <div className="row g-3">
          <div className="col-12 col-md-6">
            <label className="pr-label">Company Name{required}</label>
            <Select className="form-control pr-input" placeholder="Company Name..." options={companyOptions} value={d.company_name || ""} onChange={(v) => this.SetCompanyDraft(key, "company_name", v)} />
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">Business Type{required}</label>
            <Select className="form-control pr-input" placeholder="Business Type..." options={typeOptions} value={d.business_type || ""} onChange={(v) => this.SetCompanyDraft(key, "business_type", v)} />
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">Limit GMV / Day (THB)</label>
            <NumericFormat thousandSeparator="," decimalScale={2} allowNegative={false} type="text" className="form-control pr-input" placeholder="Unlimited" value={d.limit_gmv_per_day ?? ""} onValueChange={(v) => this.SetCompanyDraft(key, "limit_gmv_per_day", v.value)} />
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">Limit GMV / Month (THB)</label>
            <NumericFormat thousandSeparator="," decimalScale={2} allowNegative={false} type="text" className="form-control pr-input" placeholder="Unlimited" value={d.limit_gmv_per_month ?? ""} onValueChange={(v) => this.SetCompanyDraft(key, "limit_gmv_per_month", v.value)} />
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">PresentGateway</label>
            <Select className="form-control pr-input" placeholder="PresentGateway..." options={PROCESS_TYPE_SELECT} value={d.process_type || ""} onChange={(v) => this.SetCompanyDraft(key, "process_type", v)} default={false} />
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">Legal Name (seller)</label>
            <input type="text" className="form-control pr-input" maxLength={255} placeholder="Registered company name" value={d.legal_name ?? ""} onChange={(e) => this.SetCompanyDraft(key, "legal_name", e.target.value)} />
          </div>
          <div className="col-12">
            <label className="pr-label">Address (seller)</label>
            <textarea className="form-control pr-input" rows={2} maxLength={1000} placeholder="Registered address" value={d.legal_address ?? ""} onChange={(e) => this.SetCompanyDraft(key, "legal_address", e.target.value)} />
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">Tax ID</label>
            <input type="text" inputMode="numeric" className={`form-control pr-input ${isTaxIdValid(d.tax_id) ? "" : "is-invalid"}`} maxLength={13} placeholder="13 digits" value={d.tax_id ?? ""} onChange={(e) => this.SetCompanyDraft(key, "tax_id", onlyDigits(e.target.value))} />
            {!isTaxIdValid(d.tax_id) && <div className="text-danger" style={{ fontSize: 12 }}>Tax ID must be exactly 13 digits</div>}
          </div>
          <div className="col-12 col-md-6">
            <label className="pr-label">Phone</label>
            <input type="text" inputMode="tel" className="form-control pr-input" maxLength={30} placeholder="Phone" value={d.phone ?? ""} onChange={(e) => this.SetCompanyDraft(key, "phone", e.target.value)} />
          </div>
        </div>
        {!is_new && (
          <div className="gc-usages">
            {this.renderUsageBar("Used today (all brokers)", company.usage_today, company.limit_gmv_per_day)}
            {this.renderUsageBar("Used this month (all brokers)", company.usage_month, company.limit_gmv_per_month)}
          </div>
        )}
        {!is_new && company.brokers?.length > 0 && (
          <div className="gc-brokers">
            {company.brokers.map((b, i) => (
              <span key={`${b.uid}-${i}`} className={`gc-broker ${b.is_active ? "" : "off"}`} title={b.is_active ? "Active" : "Inactive"}>{b.name}</span>
            ))}
          </div>
        )}
        {CAN_EDIT_COMPANY && (
          <div className="gc-card-foot">
            {is_new ? (
              <button type="button" className="gc-cancel" onClick={() => this.RemoveCompanyDraft(key)}>Cancel</button>
            ) : (
              <button type="button" className="gc-del" disabled={company.broker_count > 0} title={company.broker_count > 0 ? "Change the brokers using this company first" : "Delete"} onClick={() => this.DeleteCompany(company)}>
                <span className="icon me-1">{"\uf2ed"}</span>Delete
              </button>
            )}
            <button type="button" className="ar-btn-gold" disabled={!changed || saving} onClick={() => this.SaveCompany(key, company)}>
              <span className="icon me-2">{"\uf0c7"}</span>{saving ? "Saving..." : is_new ? "Add company" : "Save"}
            </button>
          </div>
        )}
      </div>
    );
  };
  renderCompanies = () => {
    const { gateways, companies, companies_loaded, company_gateway, company_drafts } = this.state;
    const names = [...new Set([...gateways.map((g) => g.gateway_name), ...companies.map((c) => c.gateway_name)].filter(Boolean))].sort();
    const list = companies.filter((c) => c.gateway_name === company_gateway);
    const drafts = Object.entries(company_drafts).filter(([k, v]) => k.startsWith("new-") && v.gateway_name === company_gateway);
    return (
      <>
        <div className="gc-gateways">
          {names.map((name) => {
            const count = companies.filter((c) => c.gateway_name === name).length;
            const selected = name === company_gateway;
            return (
              <button type="button" key={name} className={`gc-gw ${selected ? "active" : ""} ${count ? "" : "empty"}`} onClick={() => this.setState({ company_gateway: name })}>
                <GatewayLogo name={name} size={32} on_dark={selected} />
                <span className="gc-gw-name">{name}</span>
                <span className="gc-gw-count" title={`${count} compan${count === 1 ? "y" : "ies"}`}>{count}</span>
              </button>
            );
          })}
        </div>

        {company_gateway ? (
          <>
            <div className="gc-head">
              <div className="d-flex align-items-center gap-3">
                <GatewayLogo name={company_gateway} size={40} on_dark />
                <div>
                  <div className="gc-head-title">{company_gateway}</div>
                  <div className="gc-head-sub">{list.length} compan{list.length === 1 ? "y" : "ies"} · limits are shared by every broker using the company</div>
                </div>
              </div>
              {CAN_EDIT_COMPANY && (
                <button type="button" className="gc-add" onClick={this.AddCompanyDraft}>
                  <span className="icon me-2">{"\uf067"}</span>Add company
                </button>
              )}
            </div>
            {!companies_loaded ? (
              <div className="gc-empty">Loading...</div>
            ) : list.length === 0 && drafts.length === 0 ? (
              <div className="gc-empty">
                <span className="icon d-block mb-2">{"\uf1ad"}</span>
                No company on {company_gateway} yet.{CAN_EDIT_COMPANY ? " Click Add company to create one." : ""}
              </div>
            ) : (
              <div className="gc-grid">
                {drafts.map(([k]) => this.renderCompanyCard(k, null))}
                {list.map((c) => this.renderCompanyCard(c.uid, c))}
              </div>
            )}
          </>
        ) : (
          <div className="gc-empty">Select a gateway above.</div>
        )}
      </>
    );
  };

  // ---- Payment Switch -------------------------------------------------
  renderSystemSwitchCard = (currency) => {
    const on_count = PAYMENT_DIRECTIONS.filter(
      (dir) => !!this.state[currency[`${dir.key}_key`]]
    ).length;
    const tone = on_count === 2 ? "on" : on_count === 0 ? "off" : "part";
    return (
      <div className="col-12 col-xl-6" key={currency.code}>
        <div className="pu-section h-100 mb-0">
          <div className="pu-section-title">
            <span className="icon">{""}</span>
            {currency.label}
            <span className="pu-currency-tag ms-1">{currency.code}</span>
            <span className={`pu-cc-count ms-auto ${tone}`}>
              {on_count}/2 active
            </span>
          </div>
          <div className="d-grid gap-2">
            {PAYMENT_DIRECTIONS.map((dir) => {
              const field = currency[`${dir.key}_key`];
              const on = !!this.state[field];
              return (
                <React.Fragment key={dir.key}>
                  {this.renderToggle({
                    icon: dir.key === "deposit" ? "" : "",
                    title: dir.label,
                    desc: on
                      ? `New ${dir.label.toLowerCase()} requests are accepted`
                      : `All ${dir.label.toLowerCase()} requests are blocked`,
                    checked: on,
                    onChange: (e) => this.setState({ [field]: e }),
                  })}
                </React.Fragment>
              );
            })}
          </div>
        </div>
      </div>
    );
  };
  renderGatewayCard = (group) => {
    const { gateways, gateways_loaded } = this.state;
    const list = gateways.filter((item) => item.country === group.code);
    if (gateways_loaded && list.length === 0 && group.optional) return null;
    return (
      <div className="col-12 col-xl-6" key={group.code}>
        <div className="pu-section h-100 mb-0">
          <div className="pu-section-title">
            <span className="icon">{""}</span>
            {group.label}
            <span className="pu-currency-tag ms-1">{group.code}</span>
            <span className="pu-cc-count ms-auto">
              {list.length} gateway{list.length === 1 ? "" : "s"}
            </span>
          </div>

          {/* Per-direction summary + bulk action */}
          <div className="pu-cc-dirs">
            {PAYMENT_DIRECTIONS.map((dir) => {
              const active = list.filter((item) => item[dir.gateway_key]).length;
              const field = group[`${dir.key}_key`];
              const system_off = field ? !this.state[field] : false;
              const tone =
                active === 0 ? "off" : active === list.length ? "on" : "part";
              return (
                <div className="pu-cc-dir" key={dir.key}>
                  <div className="pu-cc-dir-label">
                    <span className="icon me-1">
                      {dir.key === "deposit" ? "" : ""}
                    </span>
                    {dir.label}
                    {system_off && (
                      <span className="pu-cc-sysoff">system off</span>
                    )}
                  </div>
                  <div className="d-flex align-items-center gap-2">
                    <span className={`pu-cc-dir-count ${tone}`}>
                      {active}/{list.length}
                    </span>
                    <button
                      type="button"
                      className="pu-cc-bulk on"
                      onClick={() =>
                        this.ToggleGatewayGroup(group.code, dir.gateway_key, true)
                      }
                    >
                      All On
                    </button>
                    <button
                      type="button"
                      className="pu-cc-bulk off"
                      onClick={() =>
                        this.ToggleGatewayGroup(group.code, dir.gateway_key, false)
                      }
                    >
                      All Off
                    </button>
                  </div>
                </div>
              );
            })}
          </div>

          <div className="pu-cc-gw-head d-none d-md-flex">
            <div className="flex-fill">Gateway</div>
            {PAYMENT_DIRECTIONS.map((dir) => (
              <div className="pu-cc-gw-col" key={dir.key}>
                {dir.label}
              </div>
            ))}
          </div>
          {list.map((item) => {
            const changed = this.IsGatewayChanged(item);
            return (
              <div
                key={item.uid}
                className={`pu-cc-gw-row ${changed ? "changed" : ""}`}
              >
                <div className="flex-fill pu-gateway">
                  <GatewayLogo name={item.gateway_name} size={30} />
                  <div className="min-w-0">
                    <div className="pu-gateway-name">
                      {item.gateway_name || "-"}
                      {changed && <span className="pu-cc-unsaved">unsaved</span>}
                    </div>
                    <div className="pu-sub">{item.gateway_code || "-"}</div>
                  </div>
                </div>
                {PAYMENT_DIRECTIONS.map((dir) => {
                  const on = !!item[dir.gateway_key];
                  const field = group[`${dir.key}_key`];
                  const system_off = field ? !this.state[field] : false;
                  return (
                    <div
                      className={`pu-cc-gw-col ${system_off ? "dim" : ""}`}
                      key={dir.key}
                    >
                      <div className="pu-cc-gw-col-label d-md-none">
                        {dir.label}
                      </div>
                      <div className="pu-cc-gw-switch">
                        <span className={`pu-cc-onoff ${on ? "on" : "off"}`}>
                          {on ? "On" : "Off"}
                        </span>
                        <Switch
                          {...SWITCH_PROPS}
                          checked={on}
                          onChange={(e) =>
                            this.ToggleGateway(item.uid, dir.gateway_key, e)
                          }
                        />
                      </div>
                    </div>
                  );
                })}
              </div>
            );
          })}
          {gateways_loaded && list.length === 0 && (
            <div className="pr-empty">
              <span className="icon">{""}</span>No gateway
            </div>
          )}
          {/* Partner API answers 503 when every gateway of a direction is off */}
          {PAYMENT_DIRECTIONS.filter(
            (dir) =>
              list.length > 0 &&
              list.filter((item) => item[dir.gateway_key]).length === 0
          ).map((dir) => (
            <div className="pu-cc-warn" key={dir.key}>
              <span className="icon me-2">{""}</span>
              All {group.code} gateways are off for {dir.label.toLowerCase()} —
              the Partner API will report this service as under maintenance.
            </div>
          ))}
        </div>
      </div>
    );
  };
  renderPaymentSwitch = () => {
    const { gateways } = this.state;
    const known = PAYMENT_CURRENCIES.map((item) => item.code);
    // Gateways whose country is not one of the configured currencies still get
    // their own group, so nothing is hidden from the operator.
    const extra_groups = [
      ...new Set(
        gateways
          .map((item) => item.country)
          .filter((code) => code && !known.includes(code))
      ),
    ].map((code) => ({ code, label: "Other", optional: true }));

    return (
      <div>
        {/* LEVEL 1 — system wide */}
        <div className="pu-cc-level">
          <span className="pu-cc-level-num">1</span>
          <div>
            <div className="pu-cc-level-title">System Switch</div>
            <div className="pu-cc-level-desc">
              Master switch per currency. Turning it off blocks that direction
              for every gateway of the currency at once.
            </div>
          </div>
        </div>
        <div className="row g-3 mb-4">
          {PAYMENT_CURRENCIES.map(this.renderSystemSwitchCard)}
        </div>

        {/* LEVEL 2 — per gateway */}
        {CAN_EDIT_GATEWAY && (
          <div className="gateway-rules.update">
            <div className="pu-cc-level">
              <span className="pu-cc-level-num">2</span>
              <div>
                <div className="pu-cc-level-title">Gateway Switch</div>
                <div className="pu-cc-level-desc">
                  Enable or disable each gateway separately for deposit and
                  withdrawal. Only the Active flags are changed here — limits
                  and fees stay on the Gateway Settings page. Changes take
                  effect as soon as you press Save Configuration.
                </div>
              </div>
            </div>
            <div className="row g-3">
              {[...PAYMENT_CURRENCIES, ...extra_groups].map(
                this.renderGatewayCard
              )}
            </div>
          </div>
        )}
      </div>
    );
  };

  // ---- Sections -------------------------------------------------------
  renderGeneral = () => {
    const { cutoff_tier } = this.state;
    return (
      <div className="pu-section">
        <div className="pu-section-title">
          <span className="icon">{""}</span>Cutoff
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            {this.renderField({
              label: "Date Cutoff Tier",
              hint: "Minimum tier required for certain operations",
              children: (
                <Select
                  className="form-control pr-input"
                  placeholder="Cutoff Tier..."
                  options={Array.from({ length: 31 }, (_, i) => i + 1).map(
                    (item) => ({ value: item.toString(), label: item.toString() })
                  )}
                  value={cutoff_tier}
                  onChange={(v) => {
                    this.setState({ cutoff_tier: v });
                  }}
                  default={false}
                />
              ),
            })}
          </div>
        </div>
      </div>
    );
  };
  renderCommission = () => {
    const { dev_commission_percentage, dev_commission_percentage_lak } =
      this.state;
    return (
      <div className="pu-section">
        <div className="pu-section-title">
          <span className="icon">{""}</span>Dev Commission
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            {this.renderField({
              label: "Dev Commission THB",
              isRequired: true,
              suffix: "%",
              hint: "Percentage of THB fees allocated to development team",
              children: (
                <input
                  type="text"
                  className="form-control pr-input pu-cc-suffixed"
                  placeholder="Dev Commission THB (%)..."
                  maxLength={10}
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({ dev_commission_percentage: e.target.value });
                  }}
                  value={dev_commission_percentage}
                />
              ),
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.renderField({
              label: "Dev Commission LAK",
              isRequired: true,
              suffix: "%",
              hint: "Percentage of LAK fees allocated to development team",
              children: (
                <input
                  type="text"
                  className="form-control pr-input pu-cc-suffixed"
                  placeholder="Dev Commission LAK (%)..."
                  maxLength={10}
                  onChange={(e) => {
                    if (!float(e.target.value)) return;
                    this.setState({
                      dev_commission_percentage_lak: e.target.value,
                    });
                  }}
                  value={dev_commission_percentage_lak}
                />
              ),
            })}
          </div>
        </div>
      </div>
    );
  };
  renderSafety = () => {
    const { safety_balance, safety_balance_lak } = this.state;
    return (
      <div className="pu-section">
        <div className="pu-section-title">
          <span className="icon">{""}</span>Payout Notification
        </div>
        <div className="row">
          <div className="col-12 col-md-6">
            {this.renderField({
              label: "Safety Balance Payout Noti (THB)",
              suffix: "THB",
              hint: "The minimum payout balance amount that triggers a notification.",
              children: (
                <NumericFormat
                  thousandSeparator=","
                  decimalScale={2}
                  type="text"
                  className="form-control pr-input pu-cc-suffixed"
                  placeholder="Safety Balance Payout Noti (THB)..."
                  value={safety_balance}
                  onValueChange={(values) =>
                    this.setState({ safety_balance: values.value })
                  }
                />
              ),
            })}
          </div>
          <div className="col-12 col-md-6">
            {this.renderField({
              label: "Safety Balance Payout Noti (LAK)",
              suffix: "LAK",
              hint: "The minimum payout balance amount that triggers a notification.",
              children: (
                <NumericFormat
                  thousandSeparator=","
                  decimalScale={2}
                  type="text"
                  className="form-control pr-input pu-cc-suffixed"
                  placeholder="Safety Balance Payout Noti (LAK)..."
                  value={safety_balance_lak}
                  onValueChange={(values) =>
                    this.setState({ safety_balance_lak: values.value })
                  }
                />
              ),
            })}
          </div>
        </div>
      </div>
    );
  };
  announceEnd = () => {
    const { announce_datetime, announce_duration } = this.state;
    if (!announce_datetime) return null;
    return new Date(
      new Date(announce_datetime).setMinutes(
        new Date(announce_datetime).getMinutes() + Number(announce_duration || 0)
      )
    );
  };
  renderAnnouncement = () => {
    const { announce_datetime, announce_duration, announce_detail } = this.state;
    const end = this.announceEnd();
    return (
      <div className="row g-3">
        <div className="col-12 col-xl-6">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>Announcement
            </div>
            <div className="row">
              <div className="col-12 col-md-7">
                {this.renderField({
                  label: "Announce Datetime",
                  children: (
                    <input
                      type="datetime-local"
                      className="form-control pr-input"
                      placeholder="Announce Datetime..."
                      onChange={(e) => {
                        this.setState({ announce_datetime: e.target.value });
                      }}
                      value={announce_datetime}
                    />
                  ),
                })}
              </div>
              <div className="col-12 col-md-5">
                {this.renderField({
                  label: "Duration",
                  suffix: "MIN",
                  children: (
                    <input
                      type="text"
                      className="form-control pr-input pu-cc-suffixed"
                      placeholder="Duration..."
                      onChange={(e) => {
                        if (!float(e.target.value)) return;
                        this.setState({ announce_duration: e.target.value });
                      }}
                      value={announce_duration}
                    />
                  ),
                })}
              </div>
            </div>
            <div className="pu-hint mb-3 mt-0">
              Date and time for system announcements or maintenance
              notifications
            </div>
            {this.renderField({
              label: "Announce Detail",
              hint: "One line per bullet point",
              children: (
                <textarea
                  className="form-control pr-input"
                  placeholder="Announce Detail..."
                  rows={8}
                  onChange={(e) => {
                    this.setState({ announce_detail: e.target.value });
                  }}
                  value={announce_detail}
                />
              ),
            })}
          </div>
        </div>
        <div className="col-12 col-xl-6">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>Preview
              <span className="pu-cc-count ms-auto">
                {announce_datetime
                  ? `${format_date(announce_datetime, "hh:mm")} - ${
                      end ? format_date(end, "hh:mm", "en") : ""
                    }`
                  : "No schedule"}
              </span>
            </div>
            <div className="pu-cc-preview">
              <div
                className="position-relative flex-shrink-0"
                style={{ width: 720, zoom: 0.55, background: "transparent" }}
              >
                <img
                  src={NOTIFICATION}
                  alt="preview"
                  className="img-fluid rounded-3"
                />
                <div
                  className="text-center position-absolute w-100"
                  style={{ top: "34%", color: "#ffffff" }}
                >
                  <div className="fw-bold" style={{ fontSize: 40 }}>
                    {announce_datetime
                      ? format_date(announce_datetime, " dd mmmm yyyy", "en")
                      : "-"}
                  </div>
                  <div
                    className="fw-bold"
                    style={{ marginTop: -12, fontSize: 40 }}
                  >
                    {announce_datetime
                      ? `${format_date(announce_datetime, "hh:mm")} - ${
                          end ? format_date(end, "hh:mm", "en") : ""
                        }`
                      : ""}
                  </div>
                </div>
                <div
                  className="text-center position-absolute w-100"
                  style={{ top: "52%", color: "#ffffff", padding: "0% 15%" }}
                >
                  <div
                    className="mx-auto text-start"
                    style={{ fontSize: 20, whiteSpace: "pre-line" }}
                  >
                    {announce_detail ? (
                      <ul>
                        {announce_detail.split("\n").map((e, i) => (
                          <li key={i}>{e}</li>
                        ))}
                      </ul>
                    ) : (
                      "-"
                    )}
                  </div>
                </div>
              </div>
            </div>
            <div className="pu-hint">
              ตัวอย่างประกาศที่จะส่งเข้าห้อง (Send notification)
            </div>
          </div>
        </div>
      </div>
    );
  };
  renderSummary = () => {
    const {
      cutoff_tier,
      dev_commission_percentage,
      dev_commission_percentage_lak,
      safety_balance,
      safety_balance_lak,
      announce_datetime,
      announce_duration,
      announce_detail,
    } = this.state;
    const end = this.announceEnd();
    const onoff = (on) => (
      <span className={`pu-cc-onoff ${on ? "on" : "off"}`}>
        {on ? "ON" : "OFF"}
      </span>
    );
    return (
      <div className="row g-3">
        <div className="col-12 col-lg-6">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>General & Commission
            </div>
            {this.kv("Date Cutoff Tier", cutoff_tier || "-")}
            {this.kv("Dev Commission THB", `${dev_commission_percentage || "0"}%`)}
            {this.kv(
              "Dev Commission LAK",
              `${dev_commission_percentage_lak || "0"}%`
            )}
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>Safety Balance
            </div>
            {this.kv("Payout Noti (THB)", toFixed(safety_balance), "pu-amount-gold")}
            {this.kv("Payout Noti (LAK)", toFixed(safety_balance_lak), "pu-amount-gold")}
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>Payment Switch
            </div>
            {PAYMENT_CURRENCIES.map((currency) =>
              PAYMENT_DIRECTIONS.map((dir) => (
                <div className="pu-kv" key={`${currency.code}-${dir.key}`}>
                  <span className="pu-kv-label">
                    {currency.code} {dir.label}
                  </span>
                  {onoff(!!this.state[currency[`${dir.key}_key`]])}
                </div>
              ))
            )}
          </div>
        </div>
        <div className="col-12 col-lg-6">
          <div className="pu-section h-100 mb-0">
            <div className="pu-section-title">
              <span className="icon">{""}</span>Announcement
            </div>
            {this.kv(
              "Next Announcement",
              announce_datetime
                ? format_date(announce_datetime, "dd/mm/yyyy hh:mm")
                : "-"
            )}
            {this.kv(
              "Until",
              announce_duration && end ? format_date(end, "dd/mm/yyyy hh:mm") : "-"
            )}
            {this.kv("Duration", announce_duration ? `${announce_duration} min` : "-")}
            <div className="pu-kv-label mt-2 mb-1">Announcement Detail</div>
            {announce_detail ? (
              <ul className="pu-cc-detail mb-0">
                {announce_detail.split("\n").map((e, i) => (
                  <li key={i}>{e}</li>
                ))}
              </ul>
            ) : (
              <div className="pu-kv-value">-</div>
            )}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      announce_datetime,
      announce_duration,
      announce_detail,
      active_section,
      modal_share,
      share_image,
      chat_id,
    } = this.state;
    const section = SECTIONS.find((s) => s.key === active_section) || SECTIONS[0];
    const changed_count = CAN_EDIT_GATEWAY ? this.ChangedGateways().length : 0;
    return (
      <div className="w-100 min-vh-100 premium-report pr-scope pu-scope">
        <Navbar />
        <div className="body p-3 mt-3 pu-has-actionbar">
          {/* HERO */}
          <div className="ar-hero mb-4">
            <div className="ar-hero-head">
              <div>
                <div className="ar-eyebrow mb-1">Settings</div>
                <div className="ar-title">System Configuration</div>
                <div className="ar-subtitle">
                  Configure global system settings and parameters
                </div>
              </div>
              <div className="pu-cc-status">
                {PAYMENT_CURRENCIES.map((currency) => (
                  <div className="pu-cc-status-item" key={currency.code}>
                    <span className="pu-cc-status-code">{currency.code}</span>
                    {PAYMENT_DIRECTIONS.map((dir) => {
                      const on = !!this.state[currency[`${dir.key}_key`]];
                      return (
                        <span
                          className={`pu-cc-status-dir ${on ? "on" : "off"}`}
                          key={dir.key}
                        >
                          <span className={`pu-legend-dot ${on ? "on" : "off"}`} />
                          {dir.label}
                        </span>
                      );
                    })}
                  </div>
                ))}
                <div className="ar-toolbar-hint">System switch status</div>
              </div>
            </div>

            {/* SECTION TABS */}
            <div className="ar-toolbar mt-3">
              <span className="ar-toolbar-label">
                <span className="icon me-2">{""}</span>Section
              </span>
              <div className="ar-divider d-none d-md-block" />
              <div className="pu-tabs pu-tabs-dark mb-0">
                {SECTIONS.map((s) => (
                  <button
                    type="button"
                    key={s.key}
                    className={`pu-tab ${active_section === s.key ? "active" : ""}`}
                    onClick={() => (s.key === "companies" ? this.OpenCompanies() : this.setState({ active_section: s.key }))}
                  >
                    <span className="icon me-2">{s.icon}</span>
                    {s.label}
                  </button>
                ))}
              </div>
            </div>
          </div>

          {/* CONTENT */}
          <div className="pu-cc-panel">
            {this.renderSectionHead(section)}
            {active_section === "general" && this.renderGeneral()}
            {active_section === "commission" && this.renderCommission()}
            {active_section === "safety" && this.renderSafety()}
            {active_section === "payment" && this.renderPaymentSwitch()}
            {active_section === "companies" && this.renderCompanies()}
            {active_section === "announcement" && this.renderAnnouncement()}
            {active_section === "summary" && this.renderSummary()}
          </div>
        </div>

        {/* ACTION BAR (แท็บ Config Company บันทึกทีละ company ในการ์ดเอง) */}
        <div className={`pu-actionbar ${active_section === "companies" ? "d-none" : ""}`}>
          <div className="pu-actionbar-info d-none d-md-block">
            {changed_count ? (
              <>
                <b>{changed_count}</b> gateway change
                {changed_count === 1 ? "" : "s"} unsaved
                <span className="mx-2">·</span>
              </>
            ) : null}
            Editing <b>{section.label}</b>
          </div>
          <button
            className="ar-btn-ghost"
            onClick={() => {
              this.Share();
            }}
          >
            <span className="icon me-2">{""}</span>Send notification
          </button>
          <button
            className="ar-btn-ghost"
            onClick={async () => {
              await this.Get();
              if (CAN_EDIT_GATEWAY) await this.GetGateways();
            }}
          >
            <span className="icon me-2">{""}</span>Reset Change
          </button>
          <button
            className="center-configs.update ar-btn-gold"
            onClick={() => {
              this.Update();
            }}
          >
            <span className="icon me-2">{""}</span>Save Configuration
          </button>
        </div>

        {/* SHARE (hidden capture target) */}
        <div className="body" style={{ opacity: 0, position: "absolute", left: -9999 }}>
          <div className="position-relative" id="share" style={{background: 'transparent', width: 720}} ref={(el) => (this.share = el)} >
            <img src={NOTIFICATION} alt="Logo" className="img-fluid rounded-3" crossOrigin="anonymous"/>
            <div className="text-center position-absolute w-100" style={{ top: "34%", color: "#ffffff" }}>
              <div className="fw-bold noti-text-date" style={{fontSize: 40}}>{format_date(announce_datetime, " dd mmmm yyyy", "en")}</div>
              <div className="fw-bold noti-text-time" style={{ marginTop: -12, fontSize: 40 }}>
                {format_date(announce_datetime, "hh:mm")} -{" "}
                {format_date(new Date(new Date(announce_datetime).setMinutes(new Date(announce_datetime).getMinutes() + Number(announce_duration || 0))), "hh:mm", "en")}
              </div>
            </div>
            <div className="text-center position-absolute w-100" style={{ top: "52%", color: "#ffffff", padding: "0% 15%" }}>
              <div className="mx-auto text-start noti-text-detail" style={{fontSize: 20, whiteSpace: "pre-line"}}>
                {announce_detail ? (<ul>{announce_detail.split("\n").map((e,i) => (<li key={i}>{e}</li>))}</ul>) : ("-")}
              </div>
            </div>
          </div>
        </div>

        <Modal
          show={modal_share}
          onHide={() => this.setState({ modal_share: false })}
          dialogClassName="pr-modal pr-scope pu-scope"
          centered
        >
          <Modal.Header className="pr-modal-header" closeButton>
            <div>
              <div className="pr-modal-eyebrow">Announcement</div>
              <h5 className="fw-bold mb-0">Send notification</h5>
            </div>
          </Modal.Header>
          <Modal.Body className="pr-modal-body">
            <div className="pu-cc-share-img mb-3">
              <img alt="share" src={share_image} width={"100%"} />
            </div>
            <label className="pr-label">Share to Group</label>
            <Select
              className="form-control pr-input"
              placeholder="Share to Group..."
              options={global.chat_room.flatMap(group =>
                group?.list?.map(chat => ({ value: chat.value, label: chat.label })) || []
              )}
              value={chat_id}
              onChange={(v) => this.setState({ chat_id: v })}
            />
          </Modal.Body>
          <Modal.Footer className="pr-modal-footer justify-content-between">
            <button
              type="button"
              className="pu-copy-btn"
              onClick={() => {
                this.DownloadShare();
              }}
            >
              <span className="icon me-2">{""}</span>Download
            </button>
            <div className="d-flex">
              <button
                className="btn btn-dark px-5 me-1 rounded-pill"
                onClick={() => {
                  this.SubmitShare();
                }}
              >
                <span className="icon me-2">{""}</span>Share
              </button>
              <button
                className="btn btn-outline-dark px-5 ms-1 rounded-pill"
                onClick={() => {
                  this.setState({ modal_share: false });
                }}
              >
                Cancel
              </button>
            </div>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
